module.exports = __webpack_public_path__ + "media/icons/switch_black@3x-cff53bfd.svg";